import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"
import Typewriter from 'typewriter-effect';

import '../components/GlobalStyle.css';

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';
import LogoScroll from '../components/HomeComponents/LogoScroll';
import { CTA } from '../components/Layout/CTA';
import QuoteCarousel from '../components/HomeComponents/HomeCarousel';
import { FadeLoad, FadeLoadDelay, FadeScroll } from '../components/styled/Motion.styled';
import { BPSPrimaryButton } from '../components/styled/Buttons';
import { HomeAccordion1, HomeAccordion2 } from '../components/HomeComponents/HomeAccordions';
import { ProductCards1, ProductCards2, SponsorCards } from '../components/HomeComponents/HomeCards';


import HomeSplash from '../assets/images/Home - Splash.png';
import Mountain from '../assets/images/Home - Say Yes.png';
import { QuotationMark, QuoteSection } from '../components/styled/BPSQuotes';
import ProgramsAppearList from '../components/HomeComponents/ProgramAnimation';



const Home = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Best Payment Solutions | Home</title>
                <link rel="canonical" href="https://bestpayment.solutions" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75 py-5 circle-bg-5-scroll'>
                <Row className='align-items-center justify-content-evenly py-4 text-center text-xl-start'>
                    <Col xxl={4} lg={5} md={8}>
                        <FadeLoad>
                            <h1 className='fw-900 fs-60'>A better way to manage your <ProgramsAppearList /> program
                            </h1>
                            <p className='my-4'>
                                We handle everything your incentive program needs, from marketing and customer service to payments and reporting. So sit back and relax. Your program is in the best hands.
                             </p>
                            <BPSPrimaryButton href='/schedule-demo' className='d-none d-lg-inline'>Schedule a Demo</BPSPrimaryButton>
                        </FadeLoad>
                    </Col>
                    <Col xl={6} md={10} sm={12}>
                        <FadeLoadDelay>
                            <img src={HomeSplash} width='100%' />
                        </FadeLoadDelay>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 text-center py-5 bg-cream'>
                <Row className="justify-content-center pt-5">
                    <Col xl={3}>
                        <h3 className='fw-bold'>This is what success looks like with Best Payment Solutions</h3>
                    </Col>
                </Row>
                <Row className='py-md-5 justify-content-evenly'>
                    <Col lg={3} md={6} className='py-3'>
                        <h5 className='fs-48 fw-bold'>90 days or less</h5>
                        <p>
                            to get your program up and running, with some programs up in as little as 30 days.
                        </p>
                    </Col>
                    <Col lg={3} md={6} className='py-3'>
                        <h5 className='fs-48 fw-bold'>300%</h5>
                        <p>
                            average increase in successful rebate processing for our clients
                        </p>
                    </Col>
                    <Col lg={3} md={12} className='py-3'>
                        <h5 className='fs-48 fw-bold'>400%</h5>
                        <p>
                            average increase in referrals for our clients
                        </p>
                    </Col>
                </Row>
                <Row className='justify-content-evenly'>
                    <Col lg={3} md={6} className='py-3'>
                        <h5 className='fs-48 fw-bold'>1-2 days</h5>
                        <p>
                            faster processing times on payouts compared to competition
                        </p>
                    </Col>
                    <Col lg={3} md={6} className='py-3'>
                        <h5 className='fs-48 fw-bold'>$150,000</h5>
                        <p>
                            yearly savings for our clients after switching to us from a competitor
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 text-center py-5'>
                <Row className="justify-content-center py-5">
                    <Col xxl={4}>
                        <FadeScroll>
                            <h3 className='fs-48'>We empower our clients</h3>
                            <p>
                                We are more than a service provider; we are a service partner. Our collaborative approach ensures we deeply understand our clients’ needs and support them with each step in reaching their goals.
                            </p>
                            <p>
                                From small businesses to Fortune 500 corporations to municipalities, we’re here to help. When you succeed, we succeed!
                            </p>
                        </FadeScroll>
                    </Col>
                    <Col xs={12}>
                        <LogoScroll />
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 py-md-5'>
                <Row className="justify-content-evenly py-5">
                    <Col lg={5}>
                        <h3 className='fs-48'>Reaching your goals is as easy as saying “Yes”</h3>
                        <p>
                            When you say “yes” to Best Payment Solutions, you gain access to our cutting-edge technology platforms and expert team with over 20 years of industry experience. Our technology and team ensure you have a seamless process from start to finish. We ensure that you’re perfectly prepared to tackle any challenges and achieve your objectives.
                        </p>
                    </Col>
                    <Col lg={5} className='pt-4 pt-md-0'>
                        <HomeAccordion1 />
                    </Col>
                    <Col md={3} xs={8} className='pt-5'>
                        <FadeScroll>
                            <img src={Mountain} width='100%' alt='reach your goals' />
                        </FadeScroll>
                    </Col>
                </Row>
            </Container>
            <Container fluid className='vh-75 py-5 bg-cream'>
                <Row className="justify-content-center py-5">
                    <Col xl={6} md={8}>
                        <FadeScroll>
                            <h3 className='fs-48 text-center'>Our powerful incentive tools take the stress out of managing your program</h3>
                        </FadeScroll>
                    </Col>
                </Row>
                <Row className="justify-content-center">
                    <Col lg={11}>
                        <HomeAccordion2 />
                    </Col>
                </Row>
            </Container >
            <Container fluid className='vh-75 py-5'>
                <Row className="justify-content-evenly align-items-center py-5">
                    <Col lg={4}>
                        <h3 className='fs-48'>Elevate your business with a world-class incentive program</h3>
                        <p>
                            No matter your industry, we have solutions! Our range of incentive solutions includes:
                        </p>
                    </Col>
                    <Col lg={7}>
                        <Row>
                            <ProductCards1 />
                        </Row>
                    </Col>
                </Row>
                <Row className="justify-content-evenly py-5">
                    <Col xs={12}>
                        <h5 className='fs-24 text-center pb-5'>We also offer solutions for</h5>
                    </Col>
                    <Col xs={12}>
                        <Row className='justify-content-center'>
                            <ProductCards2 />
                        </Row>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='py-5 bg-sky-tint-3'>
                <Row className="justify-content-evenly align-items-center">
                    <Col>
                        <QuoteSection>
                            <QuotationMark />
                            <QuoteCarousel />
                        </QuoteSection>
                    </Col>
                </Row>
            </Container >
            <Container fluid className='vh-50 py-5'>
                <Row className="justify-content-evenly align-items-center">
                    <Col lg={4}>
                        <h3 className='fs-48'>Best Payment Solutions is a proud sponsor</h3>
                        <p>At Best Payment Solutions, we are committed to giving back and serving our community. That's why we partner with non-profits that are making a big difference.</p>
                    </Col>
                    <Col lg={6}>
                        <SponsorCards />
                    </Col>
                </Row>
            </Container >
            <Container fluid className='vh-75 py-5'>
                <CTA />
            </Container >
            <Footer />
        </>
    );
}

export default Home;